module.exports = __webpack_public_path__ + "static/media/play-icon.6dc4f91d.svg";